import { Component } from '@angular/core';
import { JetNetInformationComponent } from '../jetnet-information/jetnet-information.component';
import { AppDialogWrapperService } from '../../../ni-components/app-dialog-wrapper/app-dialog-wrapper.service';

@Component({
    selector: 'app-jetnet-search',
    styleUrls: ['./jetnet-search.component.scss'],
    templateUrl: './jetnet-search.component.html',
})
export class JetNetSearchComponent { 
    constructor(private appDialogWrapperService: AppDialogWrapperService) { }
    private isLoading: boolean = false;

    public tailNumberSearchChanged(tailNumber: any) {
        if (!this.isLoading) {
            this.isLoading = true;
        if (tailNumber.toString() == "[object PointerEvent]")
            tailNumber.currentTarget.value = (document.getElementById("tailNumber") as HTMLInputElement).value;

            if (tailNumber.currentTarget.value.trim() != "") {
                const dialogWrapper = this.appDialogWrapperService.open({
                    title: 'JetNet Information',
                    component: JetNetInformationComponent,
                    data: tailNumber.currentTarget.value.trim(),
                    width: '1100px'
                });
                dialogWrapper.afterClosed().subscribe((result: any) => {
                    const input = document.getElementById("tailNumber") as HTMLInputElement;
                    if (input) {
                        input.value = '';
                    }
                    this.isLoading = false;
                });
            } else {
                this.isLoading = false;
            }
        }
    }
}
